import api from './api';

const operationsService = {
  // Tasks
  getTasks: (params) => api.get('/tasks', { params }),
  getTask: (id) => api.get(`/tasks/${id}`),
  createTask: (data) => api.post('/tasks', data),
  updateTask: (id, data) => api.put(`/tasks/${id}`, data),
  assignTask: (id, userId) => api.post(`/tasks/${id}/assign`, { user_id: userId }),
  updateTaskStatus: (id, status) => api.put(`/tasks/${id}/status`, { status }),

  // QC
  getQCTasks: (params) => api.get('/qc', { params }),
  submitQCResult: (id, data) => api.post(`/qc/${id}/result`, data),

  // Dock scheduling
  getDockSlots: (warehouseId, params) =>
    api.get(`/warehouses/${warehouseId}/dock-schedule`, { params }),
  bookDockSlot: (warehouseId, data) =>
    api.post(`/warehouses/${warehouseId}/dock-schedule`, data),
  cancelDockSlot: (id) => api.delete(`/dock-schedule/${id}`),

  // Staff
  getStaffList: (params) => api.get('/staff', { params }),
  getStaffMember: (id) => api.get(`/staff/${id}`),

  // Putaway — the tenant-aware flow (Phase 3 UI).
  listPutawayJobs: (params) => api.get('/putaway/jobs', { params }),
  getPutawayJob: (id) => api.get(`/putaway/jobs/${id}`),
  createPutawayJob: (data) => api.post('/putaway/jobs', data),
  assignPutawayJob: (id, staffId) =>
    api.post(`/putaway/jobs/${id}/assign`, { staff_id: staffId }),
  // `body` includes ``bin_id`` (preferred) + ``qty`` + optional
  // ``override_reason`` when the operator picks outside the tenant's
  // allocated zones. Backend 422s with a list of valid reasons when
  // required — the UI surfaces that list to the user.
  recordPutawayItem: (jobId, itemId, body) =>
    api.post(`/putaway/jobs/${jobId}/items/${itemId}/record`, body),
  // Bulk placement: `items` is an array of ``{item_id, bin_id, qty,
  // override_reason?}`` entries. Returns per-item success/failure so
  // the UI can keep successful rows placed and re-prompt for the
  // failed ones.
  bulkRecordPutawayItems: (jobId, items) =>
    api.post(`/putaway/jobs/${jobId}/bulk-record`, { items }),
  completePutawayJob: (id) => api.post(`/putaway/jobs/${id}/complete`),

  // Ranked bin suggester. Returns ``{ bin_id, bin_code, strategy, reason,
  // alternatives: [{ bin_id, bin_code, reason }] }``. When the caller
  // omits tenant/booking, falls back to first-available in the warehouse.
  suggestBin: (params) => api.get('/putaway/suggest-bin', { params }),
};

export default operationsService;
